<template>
  <div>
    <b-card class="mb-5">
      <b-form-group label="Persönliche Daten"
                    label-size="lg"
                    label-cols=12
                    label-cols-xl=3
                    label-class="font-weight-bold"
                    class="mb-0">

        <user-data :user="this.user" :autocomplete=true></user-data>
      </b-form-group>
    </b-card>

    <b-card class="mb-5">
      <b-form-group label="Email"
                    label-size="lg"
                    label-cols=12
                    label-cols-xl=3
                    label-class="font-weight-bold"
                    class="mb-0">

        <user-email :user="this.user" :autocomplete=true></user-email>
      </b-form-group>
    </b-card>

    <b-card class="mb-5">

      <b-form-group label="Passwort ändern"
                    label-size="lg"
                    label-cols=12
                    label-cols-xl=3
                    label-class="font-weight-bold"
                    class="mb-0">

        <b-form id="passwordData" autocomplete="on" v-if="user">
          <input type="text" name="email" autocomplete="email" :value="user.email" class="d-none"/>

          <b-form-group label-for="password" label="Neues Passwort wählen" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
            <b-form-input type="password" id="password" v-model="password.value" :state="passwordStatus" autocomplete="new-password"/>
            <b-form-invalid-feedback>Mindestens 8 Zeichen</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label-for="password" label="Passwort bestätigen" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
            <b-form-input type="password" id="password-confirmation" v-model="password.confirmation" :state="confirmationStatus" autocomplete="new-password"/>
            <b-form-invalid-feedback>Beide Felder müssen übereinstimmen</b-form-invalid-feedback>
          </b-form-group>

          <b-button type="button" :disabled="sendPasswordDisabled" v-on:click="savePassword" variant="primary" class="float-right">Passwort ändern</b-button>

        </b-form>
      </b-form-group>
    </b-card>
  </div>
</template>

<script>
import UserForm from '@/components/user/Form'
import UserEmail from '@/components/user/Email'

export default {
  name: 'User',
  components: {
    userData: UserForm,
    userEmail: UserEmail
  },

  data: function () {
    return {
      user: null,
      password: {
        value: '',
        confirmation: ''
      }
    }
  },

  mounted: function () {
    this.axios.get('/users/me').then((rsp) => {
      this.user = rsp.data
    })
  },

  computed: {
    passwordStatus: function () {
      if (this.password.value === '') {
        return null
      }

      if (this.password.value.length < 8) {
        return false
      }

      return true
    },

    confirmationStatus: function () {
      if (this.password.value === '') {
        return null
      }

      if (this.password.confirmation === this.password.value) {
        return true
      }

      return false
    },

    sendPasswordDisabled: function () {
      if (this.password.value.length < 8) {
        return true
      }

      if (this.password.confirmation !== this.password.value) {
        return true
      }

      return false
    }
  },

  methods: {
    savePassword: function () {
      let body = JSON.stringify({
        password: this.password.value
      })

      this.axios.put('/users/me/password', body)
        .then(() => {
          this.$eventHub.$emit('info', 'Passwort erfolgreich aktualisiert')
        })

        .catch((err) => {
          this.$eventHub.$emit('error', err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/users/settings/User.vue